"use strict";

export const snapToGrid = function(position, gridSize = 16) {
	let s = Math.ceil(position / gridSize) * gridSize - gridSize/2;
	return s;
};

export const entityCollision = function(entityA, entityB) {
	const boxA = entityA.getBoundingBox()
	const boxB = entityB.getBoundingBox()
	return (boxA.x < boxB.x + boxB.width && boxA.x + boxA.width > boxB.x &&
   		boxA.y < boxB.y + boxB.height && boxA.height + boxA.y > boxB.y);
};

export const swapObjectKeys = function(obj1, obj2, keys = []) {
	keys.forEach(function(key) {
		const swap = obj1[key];
		obj1[key] = obj2[key];
		obj2[key] = swap;
	});
}


/** WEBPACK FOOTER **
 ** ./~/jshint-loader!./src/util/utils.js
 **/